<button class="badge-container">
  <evc-avatar [avatar]="avatar()"></evc-avatar>
  <div class="badge-container__infos">
    <p class="badge-container__title">{{ currentText() }}</p>
    <p class="badge-container__role">{{ additionalText() }}</p>
  </div>
  <ng-content />
</button>
